// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { func, object, string } from 'prop-types'
import SortIcon from 'components/DataTable/SortIcon'

class PathSummaryHeader extends React.Component {
  static propTypes = {
    columnKey: string.isRequired,
    handleSort: func.isRequired,
    idRoot: string.isRequired,
    tableSort: object.isRequired,
  }

  state = {
    heading: '',
  }

  componentDidMount () {
    this.setState((state, { columnHeader }) => ({
      heading: columnHeader,
    }))
  }

  assignSort = (e, col) => {
    e.stopPropagation()
    this.props.handleSort(col)
  }

  sortIcon = columnKey => {
    const {
      asc,
      col,
    } = this.props.tableSort

    return (
      <SortIcon
        asc={asc}
        showIcon={col === columnKey} />
    )
  }

  render () {
    const {
      props: { columnKey },
      sortIcon,
      state: { heading },
    } = this

    return (
      <div>
        {heading}
        {sortIcon(columnKey)}
      </div>
    )
  }
}

export default PathSummaryHeader
